import script from "./deliOnceImg8.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg8.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg8.vue?vue&type=style&index=0&id=09ad6bee&lang=less"

const __exports__ = script;

export default __exports__